var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
const StyledButton = styled.button `
  flex: 1 1 0;
  height: 40px;
  padding-left: 24px;
  padding-right: 22px;
  background: ${props => (props.selected ? "white" : "transparent")};
  box-shadow: ${props => props.selected ? "0px 3px 8px rgba(0, 0, 0, 0.10)" : "none"};
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ButtonText = styled.span `
  color: #59256b;
  font-size: 15px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: ${props => (props.selected ? 600 : 500)};
  word-wrap: break-word;
`;
const OptionButton = (_a) => {
    var { selected, children, onClick } = _a, restProps = __rest(_a, ["selected", "children", "onClick"]);
    return (React.createElement(StyledButton, Object.assign({ selected: selected, type: "button", onClick: e => {
            e.preventDefault();
            e.stopPropagation();
            if (onClick) {
                onClick(e);
            }
        } }, restProps),
        React.createElement(ButtonText, { selected: selected }, children)));
};
export default OptionButton;
